export default __webpack_public_path__ + "static/media/oracle-o-red.0122d0d8.svg";